import Constants from '../utils/consts';

var http = require('follow-redirects').http;
var fs = require('fs');
var qs = require('querystring');


export default async function manageInvestor(uname, token, subjectType, subjectId, notes, notesRaw) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/manageScheduleNotes.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            let asd = body.toString();
            
            try {
                resolve(JSON.parse(body.toString()));
            } catch (e) {
                console.error(e);
            }
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'subjectType' : subjectType,
        'subjectId' : subjectId,
        'notes' : notes,
        'notesRaw' : notesRaw,

    });

        req.write(postData);

        req.end();

        
    });
}
